import { render, staticRenderFns } from "./DPlayerSetting.vue?vue&type=template&id=7566d774&scoped=true&"
import script from "./DPlayerSetting.vue?vue&type=script&lang=js&"
export * from "./DPlayerSetting.vue?vue&type=script&lang=js&"
import style0 from "./DPlayerSetting.vue?vue&type=style&index=0&id=7566d774&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7566d774",
  null
  
)

export default component.exports